<template>
  <SearchTagGroupResult
    :isplayymovie="isplayymovie"
  />
</template>

<script>
import cookie from '@/common/utils/cookie'
import SearchTagGroupResult from '@/components/search/SearchTagGroupResult'

export default {
  name: 'SearchTagGroupMain',
  components: {
    SearchTagGroupResult
  },
  data () {
    return {
      pooqzoneInfo: cookie.getPooqZoneInfo(),
      isplayymovie: 'y'
    }
  },
  created () {
    if (this.pooqzoneInfo && this.pooqzoneInfo.isPooqzone) {
      this.isplayymovie = this.pooqzoneInfo.isplayymovie
    }
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/member.scss"></style>
